export type UseSentListParams = {
  linkId: string | null;
};

export type AlreadySentList = string[];

export const ALREADY_SENT_KEY = 'alreadySent';
